<template>
  <v-container fluid ma-0 pa-0 px-4>
    <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  Case Templates
                </h2>
              </template>
                <span>Case Templates</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Templates - <span class="font-weight-bold">{{ caseTypes.length }}</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical ></v-divider>
          <v-flex shrink fill-height class="action">
            <v-tooltip left color="secondary">
              <v-btn
                icon
                flat
                slot="activator"
                :to="newItemPath"
                >
                <v-icon color="success" size="24">add_circle</v-icon>
                  </v-btn>
                  <span>Create a new case template</span>
                </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
    <v-layout wrap >
      <v-flex xs12 pt-1>
        <v-btn
          :ripple="false" flat
          class="ml-0 mb-2 search-button"
          v-on:click="searchToggled = !searchToggled">
          <v-icon color="secondary" class="mr-2 mt-0">
            {{ searchToggled ? 'close' : 'search' }}
          </v-icon>
          {{ searchToggled ? 'Close search' : 'Search' }}
        </v-btn>
        <v-slide-y-transition>
          <v-layout row wrap class="mt-0" v-if="searchToggled">
            <v-flex
              xs12 sm6 md4
              pt-1 :class="{'pr-0 ': $vuetify.breakpoint.xsAndDown, 'pr-2': $vuetify.breakpoint.smAndUp}">
              <v-text-field
                box clearable
                class="cardcontainer-search-text pa-0 ma-0 body-1"
                v-model="searchTerm"
                @keyup.enter.native="search()"
                label="Search"
                color="secondary"
                clear-icon="cancel">
                <template slot="append">
                  <v-icon>search</v-icon>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex
              xs12 sm6 md4
              pt-1 :class="{'pl-0': $vuetify.breakpoint.xsAndDown, 'pl-2': $vuetify.breakpoint.smAndUp}">
              <v-select
                box clearable
                style="border-bottom:0 !important; "
                class="cardcontainer-order-select pa-0 ma-0 body-1"
                :items="orderByOptions"
                item-text="text"
                item-value="value"
                v-model="orderSelection"
                @change="search()"
                label="Order by"
                color="secondary"
                clear-icon="cancel"
                append-icon="keyboard_arrow_down">
              </v-select>
            </v-flex>
          </v-layout>
        </v-slide-y-transition>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="homepage-card-container card-margin-fix"  id="case-history">
      <CaseTemplateCard v-for="(caseType, index) in orderedTemplates" :key="index" :cardContent="caseType"></CaseTemplateCard>
    </v-layout>
  </v-container>
</template>

<script>
import '@/assets/styles/styles.css'
import CaseTemplateCard from '@/components/cases/case-config/CaseTemplateCard'
import { mapState } from "vuex"

export default {
  name: 'case-config-overview',
  components: { CaseTemplateCard },
  computed: {
    ...mapState({ caseTypes: state => state.caseTypes.all }),
    orderedTemplates: {
      get() {
        if (!this.localTemplateList) { this.search() }
        return this.localTemplateList
      },
      set(newList) {
        this.localTemplateList = newList
      }
    }
  },
  data: () => ({
    newItemPath: "/admin/case_types/new",
    searchToggled: false,
    orderByOptions: [{ text: "Name", value: "name" }, { text: "Date Created", value: "createdAt" }],
    searchTerm: "",
    orderSelection: undefined,
    localTemplateList: undefined
  }),
  watch: {
    searchTerm() { this.search() }
  },
  methods: {
    search() { // And Sort
      let newList = this.caseTypes
      if (this.searchTerm) {
        newList = this.caseTypes.filter((caseType) => caseType.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
      }
      if (this.orderSelection) {
        switch (this.orderSelection) {
          case "name":
            newList = this.orderByName(newList)
            break
          case "createdAt":
            newList = this.orderByCreation(newList)
            break
          default:
            break
        }
      }
      this.orderedTemplates = newList
    },
    orderByName(caseTypes) {
      if (caseTypes && caseTypes.length > 0) {
        return caseTypes.sort(function (a, b) {
          if (a.displayName < b.displayName) { return -1 }
          if (a.displayName > b.displayName) { return 1 }
          return 0
        })
      }
      return []
    },
    orderByCreation(caseTypes) {
      if (caseTypes && caseTypes.length > 0) {
        return caseTypes.sort(function (a, b) {
          if (a.id < b.id) { return -1 }
          if (a.id > b.id) { return 1 }
          return 0
        })
      }
      return []
    }
  }
}
</script>
